export enum PaymentFlowType {
  STRIPE_REDIRECT = 'STRIPE_REDIRECT',
  AUTHORIZE_NET   = 'AUTHORIZE_NET',
  BRAINTREE       = 'BRAINTREE',
  TRADITIONAL     = 'TRADITIONAL'
}

export enum PaymentContext {
  PLAN_CHANGE          = 'planChange',
  AUTO_RENEW           = 'autoRenew',
  SUBSCRIPTION         = 'subscription',
  TOP_UP               = 'topUp',
  EQUIPMENT_PURCHASE   = 'equipmentPurchase',
  ADHOC_INVOICE        = 'adhocInvoice'
}

export type GatewayKey = 'url' | 'token' | 'card';

export interface PaymentGatewayConfig {
  Status:   boolean;
  msgCode:  string;
  message:  string;
  data:     PaymentGatewayData;
  Token:    string | null;
}

export interface PaymentGatewayData {
  gateway:  GatewayInfo;
  actions:  GatewayActions;
  key:      GatewayKey;
  card?:    { value: boolean; action: 'card' };
  token?:   { value: string;  action: 'sdk' };
  url?:     { value: string;  action: 'redirect' };
}

export interface GatewayInfo {
  name:        'AuthorizeDotNet' | 'Braintree' | 'Stripe';
  description: string;
  code:        'adn' | 'braintree' | 'stripe';
}

export interface GatewayActions {
  sdk?:        string;
  redirect?:   string;
  card?:       string;
  '3ds_secure'?: boolean;
  [action: string]: any;
}

export interface CardDetails {
  cardNumber:         string;
  expirationDate:     string; // YYYY-MM
  cardCode:           string;
  nameOnCard:         string;
  cardZipCode:        string;
  cardBillingAddress: string;
  cardState:          string;
  cardCity:           string;
}

export interface BillingAddress {
  firstName?: string;
  lastName?:  string;
  address?:   string;
  city?:      string;
  state?:     string;
  zip?:       string;
}

export interface PaymentPayload {
  CustomerId: string;
  amount:     number;
  paymentMethodToken?: string; // Stripe session_id or Braintree nonce
  creditCard?:         CardDetails;
  billingAddress?:     BillingAddress;
  [key: string]:       any;
}

export interface StripePaymentDetails {
  planId?:     string;
  planName?:   string;
  amount?:     number;
  customerId?: string;
  context:     PaymentContext;
  timestamp:   number;
  returnUrl?:  string;
  metadata?:   Record<string, any>;
}

export interface BraintreeHostedFieldsConfig {
  styles?: Record<string, any>;
  fields: {
    number?:         { selector: string; placeholder?: string };
    cvv?:            { selector: string; placeholder?: string };
    expirationDate?: { selector: string; placeholder?: string };
    postalCode?:     { selector: string; placeholder?: string };
  };
}

export interface VaultedPaymentMethod {
  nonce:       string;
  type:        'CreditCard' | 'PayPalAccount';
  description: string;
  details: {
    cardType?:       string;  // Visa, Mastercard, etc.
    lastFour?:       string;
    lastTwo?:        string;
    expirationMonth?: string;
    expirationYear?:  string;
    email?:          string;  // For PayPal
    payerInfo?:      any;
  };
  default?: boolean;
}
